const SportsNews = {
	1  : "Баскетбол",
	2  : "Футбол",
	3  : "Теннис",
	4  : "Хоккей",
	5  : "Новости сайта",
	6  : "Олимпийские игры 2016",
	7  : "Бокс",
	8  : "Единоборства",
	9  : "Биатлон",
	10 : "Легкая атлетика",
	11 : "Лыжный спорт",
	12 : "Автоспорт",
	13 : "Бильярд",
	14 : "Странный спорт",
	15 : "Гимнастика",
	16 : "Керлинг",
	17 : "Интеллектуальный спорт",
	18 : "Киберспорт",
	19 : "Зимний спорт",
	20 : "Велоспорт",
	21 : "Гандбол",
	22 : "Параолимпиада",
	23 : "Американский футбол",
	24 : "Аналитика",
	25 : "Тяжелая атлетика",
	27 : "В мире"
};

export default SportsNews;


// WEBPACK FOOTER //
// ./src/app/constants/SportsNews.js